<template>
  <div class="card__table">
    <vue-audio :file="3" ref="clickCard"></vue-audio>
    <!-- Action button -->
    <div class="card__action">
      <div class="horse_user horse_preview" :class="horseColor">
        <p v-show="isDecisionCardScreen">あなたのユニコーン</p>
      </div>
      <div class="horse_pc horse_preview horse-06" v-show="isDecisionCardScreen">
        <p>競争相手のユニコーン</p>
      </div>
    </div>
    <!-- Select card -->
    <div class="card__list" v-show="currentScreen !== 'decisionCard'">
      <ul class="">
        <li class="card__item card__name">第一染色体</li>
        <li class="card__item card__name">第二染色体</li>
        <li class="card__item card__name">第三染色体</li>
        <li class="card__item card__name">性染色体</li>
        <li class="card__item">
          <card-item id="A1" :itemCard="itemCard.A1" @click="click('A1')"></card-item>
        </li>
        <li class="card__item" :class="inactiveCard">
          <card-item id="B1" :itemCard="itemCard.B1"></card-item>
        </li>

        <li class="card__item" :class="inactiveCard">
          <card-item id="C1" :itemCard="itemCard.C1"></card-item>
        </li>
        <li class="card__item" :class="inactiveCard">
          <card-item id="D1" :itemCard="itemCard.D1"></card-item>
        </li>

        <li class="card__item">
          <card-item id="A2" :itemCard="itemCard.A2" @click="click('A2')"></card-item>
        </li>
        <li class="card__item" :class="inactiveCard">
          <card-item id="B2" :itemCard="itemCard.B2"></card-item>
        </li>

        <li class="card__item" :class="inactiveCard">
          <card-item id="C2" :itemCard="itemCard.C2"></card-item>
        </li>
        <li class="card__item" :class="inactiveCard">
          <card-item id="D2" :itemCard="itemCard.D2"></card-item>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import 'gsap'
  import { store } from '../store/store'
  import CardItem from './CardItem'
  import Audio from './Audio'
  export default {
    name: 'CardList',
    props: ['horseColor', 'itemCard', 'cardId'],
    data () {
      return {
        isSelected: false,
        color: '',
        A1: {},
        A2: {}
      }
    },
    computed: {
      currentScreen () {
        return store.state.currentScreen
      },
      inactiveCard () {
        return this.currentScreen === 'specialCard' ? 'card__inactive' : ''
      },
      isDecisionCardScreen () {
        return this.currentScreen === 'decisionCard'
      }
    },
    mounted () {
      store.dispatch('setCardSuffer', true)
    },
    components: {
      'card-item': CardItem,
      'vue-audio': Audio
    },
    methods: {
      click (e) {
        if (this.currentScreen === 'specialCard') {
          this.$refs.clickCard.play()
          this.$emit('update:cardId', e)
          this.$emit('click', e)
          store.dispatch('setSpecialToCard', e)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CardList.vue?4e9788e3